import { Link } from 'react-router-dom';
import { ModuleTile } from '@platform/ui';
import { cx } from '@platform/core/lib/cx';
import type { IMenuRowViewProps } from './IMenuRowViewProps';

/**
 * Рядок меню групи (прототип v4): 40px, плитка модуля 26px із градієнтом тону, назва 600 з «…», лічильник IBM Plex Mono 11px; поточний
 * модуль — --accent-soft з акцентним текстом. Заголовок підгрупи — 11px 700 великими літерами з лінією зверху.
 */
export function MenuRowView({ row, onClose }: IMenuRowViewProps) {
  if (row.kind === 'heading') return <div className="tb-fmenu__heading" role="presentation">{row.label}</div>;
  const body = (
    <>
      <ModuleTile icon={row.icon ?? 'layout-grid'} tone={row.tone ?? 'core'} size={26} />
      <span className="tb-fmenu__name">{row.label}</span>
      {row.count !== undefined && <span className="tb-fmenu__count">{row.count}</span>}
    </>
  );
  const className = cx('tb-fmenu__item', row.active && 'is-active');
  if (row.to) {
    return (
      <Link role="menuitem" className={className} to={row.to} aria-current={row.active ? 'page' : undefined} onClick={() => { row.onSelect?.(); onClose(); }}>
        {body}
      </Link>
    );
  }
  return <button type="button" role="menuitem" className={className} onClick={() => { row.onSelect?.(); onClose(); }}>{body}</button>;
}
